import { render, staticRenderFns } from "./BusSessionCard.vue?vue&type=template&id=7a35f95e&scoped=true&"
import script from "./BusSessionCard.vue?vue&type=script&lang=js&"
export * from "./BusSessionCard.vue?vue&type=script&lang=js&"
import style0 from "./BusSessionCard.vue?vue&type=style&index=0&id=7a35f95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a35f95e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
